import { sendGTMEvent } from "@next/third-parties/google";
import { useGtmState } from "./gtm.state";
import { DEBUGGER } from "@/helper/helper";


export function initGtmTriggerGroups() {
    const { events, clear } = useGtmState.getState()

    try {
        for (const key in events) {
            if (events[key]) {
                sendGTMEvent({ event: key });
            }
        }
    } catch (e) {
        DEBUGGER(e)
    } finally {
        clear()
    }


}